
import * as PropTypes from "prop-types";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkKycSeenStatus } from "../store/actions";
import { STATUS_MODE } from "../utils/constants";
import AppBankList from "./AppBankList";
export default function AppHomeBankList() {
  const dispatch = useDispatch();
  const bankList = useSelector(({ transfer }) => transfer.connectedBanks);

  useEffect(() => {
    dispatch(checkKycSeenStatus(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 const showDashboardBank =  useCallback(function getLatestAddedBank() {
    let dashboardBank=[];
    if (Array.isArray(bankList) && bankList.length > 0) {
      for (let ii = bankList.length - 1; ii >= 0 ; ii--) {
        const bank = bankList[ii];
        if (!bank.statusSeen) {
            dashboardBank.push(bank);
            break;
        }
      }
    }
    return dashboardBank
  },[bankList])
  if(showDashboardBank().length === 0){
    return <></>
  }
  return (
    <AppBankList
      bankList={showDashboardBank()}
      mode={STATUS_MODE}
    />
  );
}

AppHomeBankList.propTypes = {
  kycStatus: PropTypes.number,
  mismatch: PropTypes.bool,
};
